import { useQuery } from 'react-query'
import { getJSON } from 'common/services/api'
import { useCallback } from 'react'
import { RiskAssessmentResponse } from "@lmc/ts-common"

const useRiskAssessmentData = (
	riskAssessmentId: string | undefined,
	onSuccess?: (data: GetRiskAssessmentQueryResponse) => void,
) => {
	const handleOnSuccess = useCallback(
		(data: GetRiskAssessmentQueryResponse) => {
			onSuccess?.(data)
		},
		[onSuccess],
	)

	const { isLoading, data, refetch, error } =
		useQuery<GetRiskAssessmentQueryResponse>(
			['risk-assessment', riskAssessmentId],
			() => getJSON({ url: getQueryUrl(riskAssessmentId) }),
			{
				onSuccess: handleOnSuccess,
				enabled: Boolean(riskAssessmentId),
				staleTime: 5 * 60 * 1000,
			},
		)

	return {
		riskAssessment: data?.result,
		isLoading,
		refetch,
		error,
	}
}

export type GetRiskAssessmentQueryResponse = {
	result?: RiskAssessmentResponse
}

const getQueryUrl = (riskAssessmentId: string | undefined) =>
	`/api/list/risk-assessments/${riskAssessmentId}`

export default useRiskAssessmentData
